import sileo from 'sileo';

const AITaskEstimation = new sileo.Model('ai', 'task-duration-estimation');
const CardAITaskEstimation = new sileo.Model('ai', 'card-ai-estimations');

const state = () => ({
  card: {},
  lastReadyCardId: null
});

const mutations = {
  SET_STATUS(state, { cardId, status }) {
    const cur = state.card[cardId] || { estimations: {}, lastUpdated: 0 };
    state.card[cardId] = { ...cur, status, lastUpdated: Date.now() };
  },

  SET_ESTIMATIONS(state, { cardId, estimations }) {
    const cur = state.card[cardId] || { status: null, lastUpdated: 0 };
    state.card[cardId] = { ...cur, estimations, lastUpdated: Date.now() };
  },

  MARK_READY(state, { cardId }) {
    state.lastReadyCardId = cardId;
  },

  CLEAR_READY(state) {
    state.lastReadyCardId = null;
  },
};

const actions = {
    fetchAITaskEstimation(context, filters={}) {
        return AITaskEstimation.objects.filter(filters);
    },

    createAITaskEstimation(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return AITaskEstimation.objects.create(form);
    },

    fetchCardAITaskEstimation(context, filters={}) {
        return CardAITaskEstimation.objects.filter(filters);
    },

    async startAndPollAIEstimation({ dispatch, commit },
      { cardId, cardTitle, maxMs = 120000, intervalMs = 2000 }) {

      commit('SET_STATUS', { cardId, status: 'PENDING' });

      const filters = { pk: cardId };

      let resp = await dispatch('fetchCardAITaskEstimation', filters);
      let prevStatus = resp?.process_status || null;
      const hasEstimates = resp?.ai_estimations && Object.keys(resp.ai_estimations).length > 0;

      if (prevStatus === 'SUCCESS') {
        commit('SET_STATUS', { cardId, status: 'SUCCESS' });
        if (hasEstimates) {
          commit('SET_ESTIMATIONS', { cardId, estimations: resp.ai_estimations });
        }
        return;
      }

      if (prevStatus !== 'RUNNING' && prevStatus !== 'PENDING') {
        if (prevStatus === 'FAILED' || !prevStatus) {
          await dispatch('createAITaskEstimation', { task_name: cardTitle, card_id: cardId });
          prevStatus = 'PENDING';
        }
      }

      commit('SET_STATUS', { cardId, status: prevStatus || 'PENDING' });

      const start = Date.now();
      while (Date.now() - start < maxMs) {
        await new Promise(r => setTimeout(r, intervalMs));
        resp = await dispatch('fetchCardAITaskEstimation', filters);
        const status = resp?.process_status || null;
        const estimateExists = resp?.ai_estimations && Object.keys(resp.ai_estimations).length > 0;
        commit('SET_STATUS', { cardId, status });

        if (status === 'FAILED') {
          return;
        }
        if (status === 'SUCCESS' && prevStatus !== 'SUCCESS') {
          if (estimateExists) {
            commit('SET_ESTIMATIONS', { cardId, estimations: resp.ai_estimations });
          }
          commit('MARK_READY', { cardId });
          return;
        }
        prevStatus = status;
      }
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
